import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAnalytics } from "use-analytics";
import MonospacedText from "~/client/components/MonospacedText";
import PageContent from "~/client/components/PageContent";
import PageHeading from "~/client/components/PageHeading";
import { useExtensionContext } from "~/client/contexts/ExtensionContext";
import { Paragraph } from "./styled";
const ExtensionPage = () => {
    const analytics = useAnalytics();
    const extensionInfo = useExtensionContext();
    useEffect(() => {
        analytics.page({ title: "Browser Extension" });
    }, [analytics]);
    return (_jsxs(PageContent, { children: [_jsx(PageHeading, { children: "Browser Extension" }), _jsx("div", { children: extensionInfo.isInstalled ? (_jsxs(Paragraph, { children: ["Tiny Recipe Clipper detected version:", " ", _jsx(MonospacedText, { children: extensionInfo.version })] })) : (_jsx(Paragraph, { children: "You either don\u2019t have Tiny Recipe Clipper installed or it is disabled." })) })] }));
};
export default ExtensionPage;
